import enUS from './en-US.js'
import enAU from './en-AU.js'
import enHYATT from './en-HYATT.js'
import enWorld from './en-001.js'
import enGB from './en-GB.js'

const messages = {
  'en-US': enUS,
  'en-AU': enAU,
  'en-HYATT': enHYATT,
  'en-001': enWorld,
  'en-GB': enGB,
};

export default messages
